import {createFilter, FilterOptionOption} from 'react-select';

const COUNTRY_ALIASES: Array<[string, string[]]> = [['Türkiye', ['Turkey', 'Turkiye']]];

const ALIAS_LOOKUP = COUNTRY_ALIASES.reduce((acc, [officialName, aliases]) => {
  const officialLower = officialName.toLowerCase();
  aliases.forEach(alias => {
    acc[alias.toLowerCase()] = officialLower;
  });
  return acc;
}, {} as Record<string, string>);

/**
 * Custom filter for country selection with alias support
 * @template Option - The option type (must have a label property)
 * @param option - The option being filtered
 * @param inputValue - The user's search input
 * @returns true if the option matches the input
 */
const customCountriesFilter = <Option = unknown>(
  option: FilterOptionOption<Option>,
  inputValue: string,
): boolean => {
  const defaultFilter = createFilter<Option>({ignoreAccents: true});
  const defaultMatch = defaultFilter(option, inputValue);

  if (defaultMatch) {
    return true;
  }

  const label = option.label?.toLowerCase() || '';
  const input = inputValue.toLowerCase();

  const officialName = ALIAS_LOOKUP[input];

  if (officialName && label.includes(officialName)) {
    return true;
  }

  for (const [alias, official] of Object.entries(ALIAS_LOOKUP)) {
    if (alias.includes(input) && label.includes(official)) {
      return true;
    }
  }

  return false;
};

export {customCountriesFilter};
